class EuropeanSteelShapesComponent extends HTMLElement {

  constructor() {
    super();
    this.shapeType = 'he-shape'
    this.selectedShape = 'HE 1000 x 584'

    this.shapeFiles = {      
      'he-shape': 'European/HE-2020.json',
      'ipe-shape': 'European/IPE-2020.json',
      'ub-shape': 'European/UB-2020.json',
      'upe-shape': 'European/UPE-2020.json',
      'upn-shape': 'European/UPN-2020.json',
      'pfc-shape': 'European/PFC-2020.json',
    }

    document.addEventListener('european-steel-shapes-selected', async () => this.onShapeCategorySelected(), true)
  }
  
  onShapeCategorySelected() {
    // update the tab
    this.onShapeFileClick(this.shapeType)
  }

  resetButton(id) {
    document.getElementById(id).classList.add('btn-default')
    document.getElementById(id).classList.remove('btn-primary')
  }

  onShapeFileClick(id) {
    this.shapeType = id
    getEuropeanSteelShapes(this.shapeFiles[id])
    // reset buttons
    this.resetButton('he-shape')
    this.resetButton('ipe-shape')
    this.resetButton('ub-shape')
    this.resetButton('upe-shape')
    this.resetButton('upn-shape')
    this.resetButton('pfc-shape')
    document.getElementById(id).classList.add('btn-primary')
  }

  connectedCallback() {

    this.innerHTML = String.raw`
    <div class="my-2">
      <button class="btn btn-default button-shadow" id='he-shape'>HE</button>
      <button class="btn btn-default button-shadow" id='ipe-shape'>IPE</button>
      <button class="btn btn-default button-shadow" id='ub-shape'>UB</button>
      <button class="btn btn-default button-shadow" id='upe-shape'>UPE</button>
      <button class="btn btn-default button-shadow" id='upn-shape'>UPN</button>
      <button class="btn btn-default button-shadow" id='pfc-shape'>PFC</button>
    </div>
    `

    document.getElementById('he-shape').onclick = (() => this.onShapeFileClick('he-shape'))
    document.getElementById('ipe-shape').onclick = (() => this.onShapeFileClick('ipe-shape'))
    document.getElementById('ub-shape').onclick = (() => this.onShapeFileClick('ub-shape'))
    document.getElementById('upe-shape').onclick = (() => this.onShapeFileClick('upe-shape'))
    document.getElementById('upn-shape').onclick = (() => this.onShapeFileClick('upn-shape'))
    document.getElementById('pfc-shape').onclick = (() => this.onShapeFileClick('pfc-shape'))

    this.onShapeFileClick('he-shape')
  } 
}

customElements.define('european-steel-shape-selector-component', EuropeanSteelShapesComponent)

